export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/id.lyaml"));
at({ "id": { "public": { "sampleString": "String contoh" } } });
};